import { sdkRequest } from '@eventbrite/http';
import { SearchAutocompleteResponse } from '../types';

const SEARCH_AUTOCOMPLETE_URL = '/api/v3/destination/search/autocomplete/';

export enum CompletionType {
    EVENT = 'event',
    QUERY = 'query',
    ORGANIZER = 'organizer',
    VENUE = 'venue',
}

export const DEFAULT_COMPLETION_TYPES: CompletionType[] = [
    CompletionType.EVENT,
    CompletionType.QUERY,
];

type BuildAutocompleteUrlParams = {
    query: string;
    placeId: string;
    latitude: number | null;
    longitude: number | null;
    completionTypes?: CompletionType[];
};

export const buildAutocompleteUrl = ({
    query,
    placeId,
    latitude,
    longitude,
    completionTypes = DEFAULT_COMPLETION_TYPES,
}: BuildAutocompleteUrlParams) => {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('completion_types', completionTypes.join(','));
    params.set('expand.destination_event', 'primary_venue,image');

    if (!placeId && latitude && longitude) {
        params.set('latitude', latitude.toString());
        params.set('longitude', longitude.toString());
    } else if (placeId) {
        params.set('place_id', placeId);
    }

    return `${SEARCH_AUTOCOMPLETE_URL}?${params.toString()}`;
};

export const searchAutocomplete = ({
    query,
    placeId,
    latitude,
    longitude,
    completionTypes = DEFAULT_COMPLETION_TYPES,
}: BuildAutocompleteUrlParams): Promise<SearchAutocompleteResponse> => {
    return sdkRequest(
        buildAutocompleteUrl({
            query,
            placeId,
            latitude,
            longitude,
            completionTypes,
        }),
    );
};
